"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_utilities_1 = require("@syl-editor/core-utilities");
var image_1 = require("@syl-editor/lib/dist/lib/formats/image");
var Icon = (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "20", viewBox: "0 0 24 24", width: "20" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" })));
var ImageController = /** @class */ (function (_super) {
    __extends(ImageController, _super);
    function ImageController(editor, store, props) {
        if (props === void 0) { props = {}; }
        var _this = _super.call(this, editor, store) || this;
        _this.toolbar = {
            className: 'image',
            tooltip: 'image',
            icon: Icon,
            handler: function (editor) {
                _this.fileInput.click();
            }
        };
        _this.editorWillUnmount = function () {
            _this.editor.root.removeChild(_this.fileInput);
        };
        _this.fileInput = image_1.Image.ImageService.ImageFileInputFactory(editor);
        editor.root.appendChild(_this.fileInput);
        if (Object.keys(props).length) {
            image_1.Image.ImageService.setImageConfiguration(props);
        }
        return _this;
    }
    return ImageController;
}(core_utilities_1.SylController));
exports.ImageController = ImageController;
//# sourceMappingURL=controller.js.map